var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 9,
    viewBox: "0 0 13 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5268 3.40402L0.793446 3.40413C0.443666 3.40413 0.160109 3.68769 0.160104 4.03747L0.160104 4.10413C0.160099 4.45391 0.443648 4.73746 0.793429 4.73746L11.5268 4.73735C11.8765 4.73735 12.1601 4.45379 12.1601 4.10401L12.1601 4.03735C12.1601 3.68757 11.8766 3.40402 11.5268 3.40402Z",
    fill: "#4C545B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5267 6.73735L0.793402 6.73746C0.443622 6.73746 0.160065 7.02102 0.160061 7.3708L0.16006 7.43747C0.160055 7.78725 0.443605 8.0708 0.793385 8.07079L11.5267 8.07069C11.8765 8.07068 12.1601 7.78713 12.1601 7.43734L12.1601 7.37068C12.1601 7.0209 11.8765 6.73735 11.5267 6.73735Z",
    fill: "#4C545B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5268 0.0706851L0.79349 0.0707943C0.443709 0.0707979 0.160153 0.354354 0.160148 0.704134L0.160147 0.770801C0.160143 1.12058 0.443692 1.40413 0.793472 1.40413L11.5268 1.40402C11.8766 1.40401 12.1601 1.12046 12.1601 0.770679L12.1601 0.704012C12.1602 0.354232 11.8766 0.0706815 11.5268 0.0706851Z",
    fill: "#4C545B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListview);
export default __webpack_public_path__ + "static/media/listview.488bde368b3b768b6eda584aa7a4eedd.svg";
export { ForwardRef as ReactComponent };